import { Communicator, ObjectManager } from '../../../concepts/objects';
import { AudioManager } from '../../../platform/AudioManager';
import { Rect } from '../../../platform/geom/Rect';
import { RelativeTo } from '../../canvas/entities/Physical';
import { ActiveObject, resolve } from '../../Container';
import { ParticleManager } from './ParticleManager';
import { Voter } from './Voter';


export class VoterController extends ActiveObject {

    @resolve(ParticleManager) private particles!: ParticleManager;
    @resolve(AudioManager) private audio!: AudioManager;
    @resolve(Communicator) private comms!: Communicator;
    @resolve(ObjectManager) private objects!: ObjectManager;

    public start() {
        this.burden(
            this.comms.recv('voter:displayResults', (_, [voterId]: [string]) => {
                this.displayResultsForLocal(voterId);
            })
        );
    }

    public displayResults(voter: Voter) {

        if (!voter?.alive) return;

        this.comms.send('voter:displayResults', [voter.id]);
        this.displayResultsForLocal(voter.id);
    }

    private displayResultsForLocal(voterId: string) {

        const voter = this.objects.getMaybe(voterId, Voter);
        if (!voter?.alive) return;

        const rects = voter.winners.map(x => {
            const i = voter.items.indexOf(x);
            return voter.layout.items[i];
        });

        for (let r of rects) {
            r = Rect.fromPoints(voter.transform(RelativeTo.Model).apply(r));
            this.particles.fireStars(r);
            this.audio.play(voter.sound);
        }
    }
}
